import React from "react";
import { SectionTitle, SingleSkill, ExpTimeline } from "../components/";
import facePhoto from "../images/home/fota_cv.webp";
import TypewriterComponent from "typewriter-effect";
import "./Home.css";

export const Home = () => {
  return (
    <>
      <div className="container">
        <div className="section odd whoami">
          <SectionTitle title="WhoAmI?" />
          <img src={facePhoto} alt="My face" />
          <p>
            {/* TODO: Adjust typing effect */}
            {/* My name is <b>Bartosz Zborowski</b>. In 2022 I&nbsp;graduated from <b>The John Paul II Catholic University of Lublin</b> with <b>Bachelor’s degree</b>. The subject of my Bachelor’s Thesis was <b>3D racing game made with Blender and Unity</b>. In 2018 I&nbsp;graduated from <b>Zespół Szkół Nr 1 in Lukow</b> technical school where I&nbsp;acquired <b>IT&nbsp;Technician Certification</b>. Few years ago I&nbsp;was diagnosed with Meniere condition. That’s when I&nbsp;became interested with programming, especially with front-end. */}
            <TypewriterComponent
              onInit={(typewriter) => {
                typewriter.changeDelay(10)
                .typeString(`My name is <b>Bartosz Zborowski</b>. In 2022 I&nbsp;graduated from <b>The John Paul II Catholic University of Lublin</b> with <b>Bachelor’s degree</b>. The subject of my Bachelor’s Thesis was <b>3D racing game made with Blender and Unity</b>. In 2018 I&nbsp;graduated from <b>Zespół Szkół Nr 1 in Lukow</b> technical school where I&nbsp;acquired <b>IT Technician Certification</b>. Few years ago I&nbsp;was diagnosed with Meniere condition. That’s when I&nbsp;became interested with programming, especially with front-end.`)
                .start();
              }}
            />
          </p>
        </div>
      </div>
      <div className="container even">
        <div className="section even skills">
          <SectionTitle title="Skills" />
          <p>
            Despite skills presented below I’ve also got <b>knowledge of English at the B2 level</b>, <b>Category B Driving License</b> since 2016, <b>Backhoe Loader Opeator Certification</b> since 2023 and <b>Counterbalance Forklift Operator Certification</b> since 2024. Repairing and building PCs are my specialities.
          </p>
          <div className="skillTree">
            <div className="skillsThird">
              <SingleSkill skillName="HTML" dots={3} />
              <SingleSkill skillName="CSS" dots={3} />
              <SingleSkill skillName="JavaScript" dots={2} />
              <SingleSkill skillName="Bootstrap" dots={3} />
              <SingleSkill skillName="React" dots={2} />
            </div>
            <div className="skillsThird">
              <SingleSkill skillName="Node.js" dots={1} />
              <SingleSkill skillName="MongoDB" dots={2} />
              <SingleSkill skillName="WordPress" dots={2} />
              <SingleSkill skillName="PHP" dots={2} />
              <SingleSkill skillName="C++" dots={2} />
            </div>
            <div className="skillsThird">
              <SingleSkill skillName="C#" dots={1} />
              <SingleSkill skillName="Unity" dots={1} />
              <SingleSkill skillName="Blender" dots={1} />
              <SingleSkill skillName="Illustrator" dots={2} />
              <SingleSkill skillName="Photoshop" dots={2} />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="section experience">
          <SectionTitle title="Commercial Experience" />
          <p>Besides commercial expierience I’ve been doing IT Technician related activities since 2016 on my own. That includes building, configuring and fixing computers, mobile phones and peripherals, as well as advising within this area.</p>
          <ExpTimeline />
        </div>
      </div>
    </>
  );
};
